import { useReportWebVitals } from '@/common';
import { HomePageContainer, type HomePageProps } from '@/containers/HomePageContainer';
import {
    HomepageHead,
    getHomepageServerSideProps,
    isLocalePathSupported,
    normalizeTld,
} from '@/components/pages/home';
import { GetServerSidePropsContext } from 'next';
import { getRequestContext } from '@/utils/requestContext';

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const localePathParam = context.params?.locale as string | undefined;

    if (localePathParam) {
        const { tld, host } = getRequestContext(context.req);
        const normalizedTld = normalizeTld(tld);

        if (!isLocalePathSupported(normalizedTld, localePathParam)) {
            return {
                redirect: {
                    destination: `https://${host}/`,
                    permanent: false,
                },
            };
        }
    }

    const handler = getHomepageServerSideProps(localePathParam);
    return handler(context);
};

export function LocaleHome(props: HomePageProps) {
    const { serverUrl } = props.env;
    const { stage } = props;

    useReportWebVitals();
    return (
        <>
            <HomepageHead serverUrl={serverUrl} stage={stage} />
            <HomePageContainer {...props} />
        </>
    );
}

export default LocaleHome;
